const rootElement = document.querySelector('[data-selector="hb-lp-multi-product-container"]')
const variantButtonElements = Array.from(rootElement.querySelectorAll('[data-selector="variant-button"]'))
const variantContainerElements = Array.from(rootElement.querySelectorAll('[data-selector="variant-container"]'))

variantButtonElements.forEach(variantButtonElement => {
  const variantId = variantButtonElement.dataset.variantId
  
  variantButtonElement.addEventListener('click', () => {
    variantButtonElements.forEach(variantContainerElement => (variantContainerElement.dataset.active = false))
    variantButtonElements.forEach(variantButtonElement => {
      if (
        variantButtonElement.dataset.variantId === variantId ||
        variantButtonElement.dataset.variantIds?.includes(variantId)
      ) {
        variantButtonElement.dataset.active = true
      }
    })

    variantContainerElements.forEach(variantContainerElement => (variantContainerElement.dataset.active = false))
    variantContainerElements.find(variantContainerElement => (variantContainerElement.dataset.variantId === variantId)).dataset.active = true
  })
})

const DEVICES = {
  'maxi-pro': {
    th: 60,
    wh: 1500,
  },
  maxi: {
    th: 39,
    wh: 1500,
  },
  trio: {
    th: 10,
    wh: 1500,
  },
  canvas: {
    th: 10,
    wh: 400,
  }
}

fetch('https://api.heatbit.com/api/v2.0/currency/rates')
.then((res) => res.json())
.then((data) => {
  const { btcPrice, hashValue } = data.body

  const calculateAndUpdateDOM = (seasonalIncomeElement) => {
    const day = 30.5
    const selectedDevice = DEVICES[seasonalIncomeElement.dataset.device]
    const th = selectedDevice.th
    const deviceNumber = 1
    const monthNumber = 6
      
    const incomeUsd = Math.round(btcPrice * hashValue * th * day * monthNumber * deviceNumber)
    
    seasonalIncomeElement.dataset.seasonalIncome = incomeUsd
    seasonalIncomeElement.innerText = incomeUsd
  }

  const seasonalIncomeElements = Array.from(rootElement.querySelectorAll('[data-selector="seasonal-income"]'))
  seasonalIncomeElements.forEach(seasonalIncomeElement => calculateAndUpdateDOM(seasonalIncomeElement))

  calculateAndUpdateDOM()
})
.catch((error) => {
  console.error('An error has occured while enabling profit calculator')
});
